import React, { createContext, useContext, useEffect, useState } from "react";
import { store } from "../lib/storage";

const CartContext = createContext(null);
export const useCart = () => useContext(CartContext);
const KEY = "smarti_cart_v1";
const TKEY = "smarti_cart_tradeins_v1";

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try { return JSON.parse(store.get(KEY)) || []; } catch { return []; }
  });

  useEffect(() => { store.set(KEY, JSON.stringify(items)); }, [items]);
  const [tradeins, setTradeins] = useState(() => {
    try { return (JSON.parse(store.get(TKEY)) || []).filter((t) => !t.expires_at || new Date(t.expires_at) > new Date()); } catch { return []; }
  });
  useEffect(() => { store.set(TKEY, JSON.stringify(tradeins)); }, [tradeins]);
  const addTradein = (t) => setTradeins((prev) => [...prev.filter((x) => x.quote_id !== t.quote_id), t].slice(-3));
  const removeTradein = (id) => setTradeins((prev) => prev.filter((x) => x.quote_id !== id));
  const updateTradein = (id, patch) => setTradeins((prev) => prev.map((x) => (x.quote_id === id ? { ...x, ...patch } : x)));

  const lineKey = (i) => `${i.product_id}|${i.color || ""}|${i.storage || ""}|${i.grade || ""}|${i.band || ""}`;

  const addItem = (item) => {
    setItems((prev) => {
      const k = lineKey(item);
      const found = prev.find((p) => lineKey(p) === k);
      if (found) return prev.map((p) => (lineKey(p) === k ? { ...p, qty: p.qty + item.qty } : p));
      return [...prev, item];
    });
  };
  const updateQty = (key, qty) =>
    setItems((prev) => prev.map((p) => (lineKey(p) === key ? { ...p, qty: Math.max(1, qty) } : p)));
  const removeItem = (key) => setItems((prev) => prev.filter((p) => lineKey(p) !== key));
  const clear = () => { setItems([]); setTradeins([]); };

  const count = items.reduce((s, i) => s + i.qty, 0);
  const subtotal = items.reduce((s, i) => s + i.unit_price * i.qty, 0);

  return (
    <CartContext.Provider value={{ items, addItem, updateQty, removeItem, clear, count, subtotal, lineKey, tradeins, addTradein, removeTradein, updateTradein }}>
      {children}
    </CartContext.Provider>
  );
}
